import { Injectable } from "@angular/core";
import { LanguageService } from "../language/language.service";

@Injectable({ providedIn: "root" })
export class HomeIaLabelMappingService {
  constructor(private readonly lang: LanguageService) {}

  mapRole(roleKey?: string | null, displayName?: string | null): string | null {
    return this.resolveLabel(displayName, roleKey, "home.datesSummary.role.");
  }

  mapReasonCode(reasonKey?: string | null, displayName?: string | null): string | null {
    return this.resolveLabel(displayName, reasonKey, "home.reasonCode.");
  }

  mapNextActionReason(reasonKey?: string | null, displayName?: string | null): string | null {
    return this.resolveLabel(displayName, reasonKey, "home.nextAction.reason.");
  }

  mapAction(actionKey?: string | null, displayName?: string | null): string | null {
    return this.resolveLabel(displayName, actionKey, "home.nextAction.action.");
  }

  private resolveLabel(displayName: string | null | undefined, rawKey: string | null | undefined, prefix: string): string | null {
    const explicit = (displayName ?? "").trim();
    if (explicit) {
      return explicit;
    }

    const raw = (rawKey ?? "").trim();
    if (!raw) {
      return null;
    }

    const normalized = this.normalizeKey(raw);
    if (normalized) {
      const key = `${prefix}${normalized}`;
      const translated = this.lang.translate(key);
      if (translated !== key) {
        return translated;
      }
    }

    return this.looksLikeHuman(raw) ? raw : null;
  }

  private normalizeKey(value: string): string | null {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    const segment = trimmed.split(".").pop() ?? trimmed;
    return segment.trim().toLowerCase().replace(/[-\s]+/g, "_");
  }

  private looksLikeHuman(value: string): boolean {
    if (/\s/.test(value)) {
      return true;
    }
    if (/[A-Z]/.test(value)) {
      return true;
    }
    return /[^a-z0-9._-]/i.test(value);
  }
}
